import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export const HEADER_MIN_HEIGHT_WITH_BORDER = 43;
export const BLOCK_MIN_HEIGHT = 362;

export default makeStyles((theme: MuiTheme) => ({
  activityTablePaper: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      minHeight: BLOCK_MIN_HEIGHT
    },
    [theme.breakpoints.down("sm")]: {
      boxShadow: "none",
      background: "transparent",
      minHeight: 0
    }
  },
  hasActivity: {},
  tabs: {
    minHeight: HEADER_MIN_HEIGHT_WITH_BORDER - 1, //-1 for borderBottom
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    },
    "& .MuiTab-root": {
      minHeight: 42,
      minWidth: 72
    },
    "& .Mui-selected .MuiTab-wrapper": {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: theme.palette.text.primary
    },
    "& .MuiTab-wrapper": {
      textTransform: "none",
      lineHeight: "normal"
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#000000",
      height: 1
    }
  },
  tabAlert: {
    "& .MuiTab-wrapper": {
      position: "relative",
      width: "auto"
    },
    "& .MuiTab-wrapper:after": {
      content: "''",
      display: "block",
      width: 6,
      height: 6,
      backgroundColor: theme.palette.warning.dark,
      top: 0,
      position: "absolute",
      right: -10,
      borderRadius: "50%"
    }
  },
  tabPanel: {
    display: "flex",
    flex: "auto",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  tabPanelWrapper: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      // minHeight: 319,
      flex: "auto"
    }
  },
  tabPanelVisible: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  section: {
    marginBottom: 24
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 16,
    color: "#595a5a",
    marginBottom: 10
  },
  content: {
    marginBottom: 14
  },
  alert: {
    "& .MuiTab-wrapper": {
      position: "relative",
      width: "auto",
      "&:after": {
        right: -8,
        top: 0,
        position: "absolute",
        content: '""',
        display: "block",
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: theme.palette.warning.dark
      }
    }
  }
}));
